export default {
    namespaced: true,
    state: {
        edit_authority: false
    },
    mutations: {
        // 編集権限をセット
        setEditAuthority(state, edit_authority) {
            state.edit_authority = edit_authority;
        }
    },
    actions: {},
    getters: {
        // 編集権限を取得
        getEditAuthority(state) {
            return state.edit_authority;
        }
    }
};
